import {
  MyClubSlugLayout,
  loaderFn,
} from '@sorare/gameplay/src/layouts/MyClubSlugLayout';

import { PageParams } from './__generated__/routeParams';

export const loader = loaderFn<PageParams>();

export default MyClubSlugLayout;
